'use client';
import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const faqs = [
  {
    id: 'faq_1',
    question: 'Lost your access code?',
    answer:
      "Your access code was sent to your email after the photo session. Check your spam/junk folder. If you still can't find it, contact us at ryansukeena@gmail.com with your name and event details.",
  },
  {
    id: 'faq_2',
    question: 'How do I download photos?',
    answer:
      'Click on any photo to view it, then click the download icon. You can also use the "Download All" button to get all photos at once in a ZIP file.',
  },
  {
    id: 'faq_3',
    question: 'Gallery not loading?',
    answer:
      "Make sure you're using the correct access code (case-sensitive). Clear your browser cache and try again. If the issue persists, contact support.",
  },
  {
    id: 'faq_4',
    question: 'How long is my gallery available?',
    answer:
      'Your gallery is available for 3 months from the event date. The expiry date is shown at the top of your gallery. Download your photos before this date.',
  },
  {
    id: 'faq_5',
    question: 'Can I share my gallery?',
    answer:
      "Your gallery is private and intended for your personal use. If you'd like to share photos, download them first and share them directly.",
  },
];

export default function HelpSection() {
  const [openFaq, setOpenFaq] = useState<string | null>(null);

  const toggleFaq = (id: string) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  return (
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-white mb-4">Need Help?</h2>
        <p className="text-muted-foreground">
          Common questions about accessing your private gallery
        </p>
      </div>

      <div className="space-y-4">
        {faqs.map((faq) => (
          <div
            key={faq.id}
            className="glass-panel rounded-xl overflow-hidden hover:bg-card transition-all duration-300"
          >
            <button
              onClick={() => toggleFaq(faq.id)}
              className="w-full px-6 py-4 flex items-center justify-between text-left"
            >
              <span className="text-lg font-semibold text-white pr-4">{faq.question}</span>
              <Icon
                name="ChevronDownIcon"
                size={24}
                className={`text-muted-foreground flex-shrink-0 transition-transform duration-300 ${
                  openFaq === faq.id ? 'rotate-180' : ''
                }`}
              />
            </button>

            <div
              className={`overflow-hidden transition-all duration-300 ${
                openFaq === faq.id ? 'max-h-48' : 'max-h-0'
              }`}
            >
              <div className="px-6 pb-4">
                <p className="text-sm text-muted-foreground leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Contact Support */}
      <div className="mt-12 text-center glass-panel rounded-2xl p-8">
        <Icon name="ChatBubbleLeftRightIcon" size={48} className="text-white mx-auto mb-4" />
        <h3 className="text-xl font-bold text-white mb-2">Still Need Help?</h3>
        <p className="text-muted-foreground mb-6">Our support team is here to assist you</p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="mailto:ryansukeena@gmail.com"
            className="px-6 py-3 bg-white text-background rounded-lg font-medium hover:bg-white/90 transition-all duration-300 flex items-center gap-2"
          >
            <Icon name="EnvelopeIcon" size={20} />
            Email Support
          </a>
          {/* <a
            href="tel:+16471234567"
            className="px-6 py-3 border border-white/20 rounded-lg font-medium text-white hover:bg-white/10 transition-all duration-300 flex items-center gap-2"
          >
            <Icon name="PhoneIcon" size={20} />
            Call Us
          </a> */}
        </div>
      </div>
    </div>
  );
}
